export const ExportExtensions = {
  xlsx: 'xlsx',
  csv: 'csv',
  pdf: 'pdf'
};
